// extracted by mini-css-extract-plugin
module.exports = {"pricingSection":"PricingPage_pricingSection__3eSIA","fadeIn":"PricingPage_fadeIn__wc1t_"};